// @ts-nocheck
/* eslint-disable */
/* tslint:disable */
/* prettier-ignore-start */

/** @jsxRuntime classic */
/** @jsx createPlasmicElementProxy */
/** @jsxFrag React.Fragment */

// This class is auto-generated by Plasmic; please do not edit!
// Plasmic Project: 9ca3sE4gAMHXGHWcmrUodR
// Component: vzjYCBMgG9
import * as React from "react";

import * as p from "@plasmicapp/react-web";
import * as ph from "@plasmicapp/host";

import {
  hasVariant,
  classNames,
  wrapWithClassName,
  createPlasmicElementProxy,
  makeFragment,
  MultiChoiceArg,
  SingleBooleanChoiceArg,
  SingleChoiceArg,
  pick,
  omit,
  useTrigger,
  StrictProps,
  deriveRenderOpts,
  ensureGlobalVariants
} from "@plasmicapp/react-web";

import "@plasmicapp/react-web/lib/plasmic.css";

import projectcss from "./plasmic_main.module.css"; // plasmic-import: 9ca3sE4gAMHXGHWcmrUodR/projectcss
import sty from "./PlasmicCanvasSidebar.module.css"; // plasmic-import: vzjYCBMgG9/css

import NotePencilFillSvgrepoComsvgIcon from "./icons/PlasmicIcon__NotePencilFillSvgrepoComsvg"; // plasmic-import: jCyTs41H0A/icon
import ListSvgrepoCom2SvgIcon from "./icons/PlasmicIcon__ListSvgrepoCom2Svg"; // plasmic-import: xCu6xUVYCR/icon
import AimSvgrepoComsvgIcon from "./icons/PlasmicIcon__AimSvgrepoComsvg"; // plasmic-import: fndZ2WsgPs/icon
import LayersSvgrepoComsvgIcon from "./icons/PlasmicIcon__LayersSvgrepoComsvg"; // plasmic-import: Z7NmGx4N2R/icon
import SelectObjectSvgrepoComsvgIcon from "./icons/PlasmicIcon__SelectObjectSvgrepoComsvg"; // plasmic-import: wtBx5jquxF/icon
import SettingsSvgrepoComsvgIcon from "./icons/PlasmicIcon__SettingsSvgrepoComsvg"; // plasmic-import: xCE9wzy0-2/icon

export type PlasmicCanvasSidebar__VariantMembers = {
  disabled: "disabled";
  state: "noteList" | "settings" | "levels" | "spaces";
  hideSettings: "hideSettings";
};

export type PlasmicCanvasSidebar__VariantsArgs = {
  disabled?: SingleBooleanChoiceArg<"disabled">;
  state?: MultiChoiceArg<"noteList" | "settings" | "levels" | "spaces">;
  hideSettings?: SingleBooleanChoiceArg<"hideSettings">;
};

type VariantPropType = keyof PlasmicCanvasSidebar__VariantsArgs;
export const PlasmicCanvasSidebar__VariantProps = new Array<VariantPropType>(
  "disabled",
  "state",
  "hideSettings"
);

export type PlasmicCanvasSidebar__ArgsType = {};
type ArgPropType = keyof PlasmicCanvasSidebar__ArgsType;
export const PlasmicCanvasSidebar__ArgProps = new Array<ArgPropType>();

export type PlasmicCanvasSidebar__OverridesType = {
  root?: p.Flex<"div">;
  freeBox?: p.Flex<"div">;
  markerButton?: p.Flex<"div">;
  listButton?: p.Flex<"div">;
  centerButton?: p.Flex<"div">;
  levelsButton?: p.Flex<"div">;
  spacesButton?: p.Flex<"div">;
  settingsButton?: p.Flex<"div">;
};

export interface DefaultCanvasSidebarProps {
  disabled?: SingleBooleanChoiceArg<"disabled">;
  state?: MultiChoiceArg<"noteList" | "settings" | "levels" | "spaces">;
  hideSettings?: SingleBooleanChoiceArg<"hideSettings">;
  className?: string;
}

function PlasmicCanvasSidebar__RenderFunc(props: {
  variants: PlasmicCanvasSidebar__VariantsArgs;
  args: PlasmicCanvasSidebar__ArgsType;
  overrides: PlasmicCanvasSidebar__OverridesType;

  forNode?: string;
}) {
  const { variants, overrides, forNode } = props;

  const $ctx = ph.useDataEnv?.() || {};
  const args = React.useMemo(
    () =>
      Object.assign(
        {},

        props.args
      ),
    [props.args]
  );

  const $props = {
    ...args,
    ...variants
  };

  const currentUser = p.useCurrentUser?.() || {};

  return (
    <div
      data-plasmic-name={"root"}
      data-plasmic-override={overrides.root}
      data-plasmic-root={true}
      data-plasmic-for-node={forNode}
      className={classNames(
        projectcss.all,
        projectcss.root_reset,
        projectcss.plasmic_default_styles,
        projectcss.plasmic_mixins,
        projectcss.plasmic_tokens,
        sty.root
      )}
    >
      <p.Stack
        as={"div"}
        data-plasmic-name={"freeBox"}
        data-plasmic-override={overrides.freeBox}
        hasGap={true}
        className={classNames(projectcss.all, sty.freeBox)}
      >
        {true ? (
          <div
            data-plasmic-name={"markerButton"}
            data-plasmic-override={overrides.markerButton}
            className={classNames(projectcss.all, sty.markerButton, {
              [sty.markerButtondisabled]: hasVariant(
                variants,
                "disabled",
                "disabled"
              )
            })}
          >
            <NotePencilFillSvgrepoComsvgIcon
              className={classNames(projectcss.all, sty.svg__hlXy2, {
                [sty.svgdisabled__hlXy2Kogvc]: hasVariant(
                  variants,
                  "disabled",
                  "disabled"
                )
              })}
              role={"img"}
            />
          </div>
        ) : null}

        <div
          data-plasmic-name={"listButton"}
          data-plasmic-override={overrides.listButton}
          className={classNames(projectcss.all, sty.listButton, {
            [sty.listButtondisabled]: hasVariant(
              variants,
              "disabled",
              "disabled"
            ),
            [sty.listButtonstate_noteList]: hasVariant(
              variants,
              "state",
              "noteList"
            )
          })}
        >
          <ListSvgrepoCom2SvgIcon
            className={classNames(projectcss.all, sty.svg___7Gb6N, {
              [sty.svgdisabled___7Gb6Nkogvc]: hasVariant(
                variants,
                "disabled",
                "disabled"
              )
            })}
            role={"img"}
          />
        </div>

        <div
          data-plasmic-name={"centerButton"}
          data-plasmic-override={overrides.centerButton}
          className={classNames(projectcss.all, sty.centerButton, {
            [sty.centerButtondisabled]: hasVariant(
              variants,
              "disabled",
              "disabled"
            )
          })}
        >
          <AimSvgrepoComsvgIcon
            className={classNames(projectcss.all, sty.svg__bK9)}
            role={"img"}
          />
        </div>

        <div
          data-plasmic-name={"levelsButton"}
          data-plasmic-override={overrides.levelsButton}
          className={classNames(projectcss.all, sty.levelsButton, {
            [sty.levelsButtondisabled]: hasVariant(
              variants,
              "disabled",
              "disabled"
            ),
            [sty.levelsButtonstate_levels]: hasVariant(
              variants,
              "state",
              "levels"
            ),
            [sty.levelsButtonstate_settings]: hasVariant(
              variants,
              "state",
              "settings"
            ),
            [sty.levelsButtonstate_spaces]: hasVariant(
              variants,
              "state",
              "spaces"
            )
          })}
        >
          <LayersSvgrepoComsvgIcon
            className={classNames(projectcss.all, sty.svg___4Lstm, {
              [sty.svgstate_levels___4LstmcLIl]: hasVariant(
                variants,
                "state",
                "levels"
              ),
              [sty.svgstate_settings___4Lstm1Gzqy]: hasVariant(
                variants,
                "state",
                "settings"
              )
            })}
            role={"img"}
          />
        </div>

        {(hasVariant(variants, "state", "spaces") ? true : true) ? (
          <div
            data-plasmic-name={"spacesButton"}
            data-plasmic-override={overrides.spacesButton}
            className={classNames(projectcss.all, sty.spacesButton, {
              [sty.spacesButtondisabled]: hasVariant(
                variants,
                "disabled",
                "disabled"
              ),
              [sty.spacesButtonstate_levels]: hasVariant(
                variants,
                "state",
                "levels"
              ),
              [sty.spacesButtonstate_settings]: hasVariant(
                variants,
                "state",
                "settings"
              ),
              [sty.spacesButtonstate_spaces]: hasVariant(
                variants,
                "state",
                "spaces"
              )
            })}
          >
            <SelectObjectSvgrepoComsvgIcon
              className={classNames(projectcss.all, sty.svg__zdrdq, {
                [sty.svgstate_levels__zdrdqcLIl]: hasVariant(
                  variants,
                  "state",
                  "levels"
                ),
                [sty.svgstate_settings__zdrdq1Gzqy]: hasVariant(
                  variants,
                  "state",
                  "settings"
                )
              })}
              role={"img"}
            />
          </div>
        ) : null}
        {(
          hasVariant(variants, "hideSettings", "hideSettings") ? true : true
        ) ? (
          <div
            data-plasmic-name={"settingsButton"}
            data-plasmic-override={overrides.settingsButton}
            className={classNames(projectcss.all, sty.settingsButton, {
              [sty.settingsButtondisabled]: hasVariant(
                variants,
                "disabled",
                "disabled"
              ),
              [sty.settingsButtonhideSettings]: hasVariant(
                variants,
                "hideSettings",
                "hideSettings"
              ),
              [sty.settingsButtonstate_settings]: hasVariant(
                variants,
                "state",
                "settings"
              )
            })}
          >
            <SettingsSvgrepoComsvgIcon
              className={classNames(projectcss.all, sty.svg__omrtk, {
                [sty.svgstate_settings__omrtk1Gzqy]: hasVariant(
                  variants,
                  "state",
                  "settings"
                )
              })}
              role={"img"}
            />
          </div>
        ) : null}
      </p.Stack>
    </div>
  ) as React.ReactElement | null;
}

const PlasmicDescendants = {
  root: [
    "root",
    "freeBox",
    "markerButton",
    "listButton",
    "centerButton",
    "levelsButton",
    "spacesButton",
    "settingsButton"
  ],
  freeBox: [
    "freeBox",
    "markerButton",
    "listButton",
    "centerButton",
    "levelsButton",
    "spacesButton",
    "settingsButton"
  ],
  markerButton: ["markerButton"],
  listButton: ["listButton"],
  centerButton: ["centerButton"],
  levelsButton: ["levelsButton"],
  spacesButton: ["spacesButton"],
  settingsButton: ["settingsButton"]
} as const;
type NodeNameType = keyof typeof PlasmicDescendants;
type DescendantsType<T extends NodeNameType> =
  typeof PlasmicDescendants[T][number];
type NodeDefaultElementType = {
  root: "div";
  freeBox: "div";
  markerButton: "div";
  listButton: "div";
  centerButton: "div";
  levelsButton: "div";
  spacesButton: "div";
  settingsButton: "div";
};

type ReservedPropsType = "variants" | "args" | "overrides";
type NodeOverridesType<T extends NodeNameType> = Pick<
  PlasmicCanvasSidebar__OverridesType,
  DescendantsType<T>
>;
type NodeComponentProps<T extends NodeNameType> =
  // Explicitly specify variants, args, and overrides as objects
  {
    variants?: PlasmicCanvasSidebar__VariantsArgs;
    args?: PlasmicCanvasSidebar__ArgsType;
    overrides?: NodeOverridesType<T>;
  } & Omit<PlasmicCanvasSidebar__VariantsArgs, ReservedPropsType> & // Specify variants directly as props
    // Specify args directly as props
    Omit<PlasmicCanvasSidebar__ArgsType, ReservedPropsType> &
    // Specify overrides for each element directly as props
    Omit<
      NodeOverridesType<T>,
      ReservedPropsType | VariantPropType | ArgPropType
    > &
    // Specify props for the root element
    Omit<
      Partial<React.ComponentProps<NodeDefaultElementType[T]>>,
      ReservedPropsType | VariantPropType | ArgPropType | DescendantsType<T>
    >;

function makeNodeComponent<NodeName extends NodeNameType>(nodeName: NodeName) {
  type PropsType = NodeComponentProps<NodeName> & { key?: React.Key };
  const func = function <T extends PropsType>(
    props: T & StrictProps<T, PropsType>
  ) {
    const { variants, args, overrides } = React.useMemo(
      () =>
        deriveRenderOpts(props, {
          name: nodeName,
          descendantNames: [...PlasmicDescendants[nodeName]],
          internalArgPropNames: PlasmicCanvasSidebar__ArgProps,
          internalVariantPropNames: PlasmicCanvasSidebar__VariantProps
        }),
      [props, nodeName]
    );

    return PlasmicCanvasSidebar__RenderFunc({
      variants,
      args,
      overrides,
      forNode: nodeName
    });
  };
  if (nodeName === "root") {
    func.displayName = "PlasmicCanvasSidebar";
  } else {
    func.displayName = `PlasmicCanvasSidebar.${nodeName}`;
  }
  return func;
}

export const PlasmicCanvasSidebar = Object.assign(
  // Top-level PlasmicCanvasSidebar renders the root element
  makeNodeComponent("root"),
  {
    // Helper components rendering sub-elements
    freeBox: makeNodeComponent("freeBox"),
    markerButton: makeNodeComponent("markerButton"),
    listButton: makeNodeComponent("listButton"),
    centerButton: makeNodeComponent("centerButton"),
    levelsButton: makeNodeComponent("levelsButton"),
    spacesButton: makeNodeComponent("spacesButton"),
    settingsButton: makeNodeComponent("settingsButton"),

    // Metadata about props expected for PlasmicCanvasSidebar
    internalVariantProps: PlasmicCanvasSidebar__VariantProps,
    internalArgProps: PlasmicCanvasSidebar__ArgProps
  }
);

export default PlasmicCanvasSidebar;
/* prettier-ignore-end */
